type IResetFiltersButtonProps = {
  resetFilters: () => void;
};

import { CloseCircleOutlined } from '@ant-design/icons';
import { Button } from 'antd';

export const ResetFiltersButton = ({
  resetFilters,
}: IResetFiltersButtonProps) => (
  <Button
    className="button reset"
    icon={<CloseCircleOutlined />}
    type="primary"
    size="small"
    htmlType="submit"
    onClick={resetFilters}
    data-testid="reset-filters"
  >
    Сброс фильтров
  </Button>
);
